import { Button, ClickAwayListener, Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react'
import { AlertDialog, FormTextField } from '../../../../components';
import { useParams } from 'react-router';
import clsx from 'clsx';
import EditIcon from '@material-ui/icons/Edit';
import { deleteApiPlan } from '../../../../actions/apiPlans';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

const Header = (props) => {
  const {
    intl,
    payload,
    classes,
    setPayload,
    apiPlanUuid,
    isApiPlanDeleteSuccess,
    setAlertMessages,
  } = props

  const [editApiPlanName, setEditPlanName] = useState(false);
  const [isApiPlanNameEmpty, setIsApiPlanNameEmpty] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [deleteApiPlanConfirm, setDeleteApiPlanConfirm] = useState(false);

  const dispatch = useDispatch();

  const handleDeleteApiPlan = () => {
    setAlertMessages({
      message: "",
      variant: "",
      status: false,
    })
    dispatch(deleteApiPlan(apiPlanUuid));
  };

  const handleChange = (value) => {
    setPayload({ ...payload, name: value });
    setIsEditing(true);
    setIsApiPlanNameEmpty(false);
  }

  const handleBlur = () => {
    setIsEditing(false);
    setIsApiPlanNameEmpty(payload.name === '');
  };

  const emptyFieldName = <span className={classes.textError}>{intl.getI18nMessage("error.field.mandatory")}</span>;

  const fieldNameHelperText = useMemo(() => {
    if (isEditing) {
      return intl.getI18nMessage("label.api.plans.add.name.field.help.text");
    }
    if (isApiPlanNameEmpty) {
      return emptyFieldName;
    }
    return intl.getI18nMessage("label.api.plans.add.name.field.help.text");
  }, [isEditing, isApiPlanNameEmpty, classes]);

  const fieldNameError = !isEditing && (isApiPlanNameEmpty);

  const params = useParams();
  const currentTab = params?.tabName;
  const isApisTab = currentTab === 'apis';
  const isOrgsTab = currentTab === 'organizations';

  useEffect(() => {
    if (isApiPlanDeleteSuccess) {
      setDeleteApiPlanConfirm(false);
    }
  }, [isApiPlanDeleteSuccess])

  const nameContainerClass = clsx(classes.flexNonBetween, classes.nameContainer);

  return (
    <div className={classes.contentPadding}>
      <Typography variant='h5'>{intl.getI18nMessage("label.api.plans.page.navigation.info.text")}</Typography>
      <div className={classes.flex}>
        <ClickAwayListener onClickAway={() => setEditPlanName(false)}>
          <div className={classes.apiPlanNameContainer}>
            {editApiPlanName || !apiPlanUuid || fieldNameError || isEditing ? (
              <FormTextField
                id='add-api-plan-name-field'
                fieldContainerClass={classes.fieldContainer}
                helperText={fieldNameHelperText}
                placeholder={intl.getI18nMessage("label.apiPlans.list.name.column.title")}
                handleChange={(value) => handleChange(value)}
                value={payload.name}
                handleBlur={handleBlur}
                error={fieldNameError}
                maxLength="50"
              />
            )
              : (
                <div className={nameContainerClass}>
                  <Typography id='api-plan-name-edit' variant='h1' className={classes.apiPlanName}>{payload.name}</Typography>
                  {
                    (!isApisTab && !isOrgsTab) && (
                      <Button
                        id='api-plan-name-edit-button'
                        data-apim-test='api-plan-name-edit-button'
                        color="primary"
                        variant="outlined"
                        onClick={() => setEditPlanName(true)}
                        className={classes.editIconButton}
                      >
                        <EditIcon />
                      </Button>
                    )
                  }
                </div>
              )}
          </div>
        </ClickAwayListener>

        {
          apiPlanUuid && (
            <Button
              id='api-plans-delete-button'
              data-apim-test='api-plans-delete-button'
              variant='outlined'
              className={classes.deleteButton}
              onClick={() => setDeleteApiPlanConfirm(true)}
            >
              {intl.getI18nMessage("label.delete.button")}
            </Button>
          )
        }
      </div>

      <AlertDialog
        id="delete-api-plan-alert-dialog"
        isOpen={deleteApiPlanConfirm}
        title={intl.getI18nMessage("label.api.plans.delete.api.plan.warning.text")}
        description={intl.getI18nMessage("label.api.plans.delete.api.plan.warning.description")}
        cancelText={intl.getI18nMessage("label.login.saml.confirm.cancel")}
        submitText={intl.getI18nMessage("label.request.list.actions.ok")}
        onCancel={() => setDeleteApiPlanConfirm(false)}
        onSubmit={handleDeleteApiPlan}
      />
    </div>
  )
}

Header.propTypes = {
  intl: PropTypes.object,
  payload: PropTypes.object,
  classes: PropTypes.object,
  setPayload: PropTypes.func,
  apiPlanUuid: PropTypes.string,
  isApiPlanDeleteSuccess: PropTypes.string,
  setAlertMessages: PropTypes.object,
}

export default Header;
